// Shared inner layout for the stock Oscar account pages (wishlists / product
// alerts / notifications / email history). Renders the capped-width + side-nav
// (the account-section tabs, resolved server-side by build_account_tabs) +
// content wrappers, WITHOUT the PageSkeleton document shell -- the site's page
// template wraps this in its own PageSkeleton so the DOM is byte-identical to
// the pre-move AccountPageShell. Breadcrumbs are intentionally omitted (no
// pillows styling exists for them, matching the other account pages).
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { SideNav } from "../SideNav";

type IProps = Immutable<{
    sideNav: templates.ProfileDocumentTemplate["side_nav"];
}> & {
    children?: React.ReactNode;
};

export const AccountPageBody = (props: IProps): React.JSX.Element => (
    <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
        <div className="l-side-nav">
            <SideNav items={props.sideNav} />
        </div>
        <div className="l-side-nav-content">{props.children}</div>
    </div>
);
